<template>
  <div>
    <b-card style="margin: 1%" v-if="userInfo">
      <b-row>
        <b-col md="6" xl="6" cols="6">
          <b-form-group label-align="right" :label="$t('Bank account')" label-cols="5" label-cols-xl="5" label-cols-md="5" >
            <b-form-input type="text" v-model="userInfo.bank_account"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Comments')" label-cols="5" label-cols-xl="5" label-cols-md="5"  >
            <b-form-textarea type="text" rows="2" v-model="userInfo.comments"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Personal manager')" label-cols="5" label-cols-xl="5" label-cols-md="5" >
            <b-form-input type="text" v-model="userInfo.personal_manager"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Connection date')" label-cols="5" label-cols-xl="5" label-cols-md="5" >
            <b-form-input v-model="userInfo.connect_date" type="date"/>
          </b-form-group>
        </b-col>
        <b-col md="6" xl="6" cols="6">
          <b-form-group label-align="right" :label="$t('Passport')" label-cols="5" label-cols-xl="5" label-cols-md="5">
            <b-form-input type="text" v-model="userInfo.passport"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('ITIN')" label-cols="5" label-cols-xl="5" label-cols-md="5" >
            <b-form-input type="number" v-model="userInfo.tax_number"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Reg code')" label-cols="5" label-cols-xl="5" label-cols-md="5" >
            <b-form-input type="text" v-model="userInfo.kpp_number"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Bank')" label-cols="5" label-cols-xl="5" label-cols-md="5">
            <b-input-group>
              <b-form-input type="text" v-model="userBank.name" disabled :placeholder="$t('Tap to select')"/>
              <div style="position:absolute; left:0; right:0; top:0; bottom:0;" @click="showFormBank"/>
              <b-input-group-append>
                <b-button @click.stop="clear" variant="secondary" size="sm">{{ $t('Clear') }}</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <b-modal ref="bankUser" hide-footer :title="$t('Bank')" @hidden="isShowBankUser = false">
      <FormBank v-if="isShowBankUser" :userInfo="userInfo" @hideFormBank="hideFormBank" @load="load" @makeToasts="makeToasts"></FormBank>
    </b-modal>
  </div>
</template>

<script>

import axiosInstance from '@/utils/api.js'
import FormBank from '@/pages/users/usersAndGroups/detail/additional/formBank'

export default {
  components: {
    FormBank
  },
  props: {
    userInfo: null
  },
  data () {
    return {
      isShowBankUser: false,
      banks: [],
      userBank: ''
    }
  },
  methods: {
    clear () {
      this.userBank = ''
      this.userInfo.bank_id = '0'
    },
    showFormBank () {
      this.isShowBankUser = true
      this.$refs.bankUser.show()
    },
    hideFormBank () {
      this.isShowBankUser = false
      this.$refs.bankUser.hide()
    },
    makeToasts (variant, body, title) {
      this.$root.$emit('makeToasts', variant, body, title)
    },
    async load () {
      this.userBank = ''
      this.banks = await axiosInstance.get(this.$store.getters.API_REFERENCE_BOOKS_BANKS).then(response => { return response.data })
      for (let i in this.banks) {
        if (this.banks[i].bank_id === this.userInfo.bank_id) {
          this.userBank = this.banks[i]
          break
        }
      }
    }
  },
  watch: {
    userInfo: function (val) {
      this.load()
    }
  },
  mounted () {
    this.load()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/personal/main.vue